module.exports = __webpack_public_path__ + "img/discord-airdrop.ed1becc0.svg";